import { render } from "./Member_Details.vue?vue&type=template&id=45c2b556&scoped=true"
import script from "./Member_Details.vue?vue&type=script&lang=js"
export * from "./Member_Details.vue?vue&type=script&lang=js"

import "./Member_Details.vue?vue&type=style&index=0&id=45c2b556&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c2b556"]])

export default __exports__